import React, { useState } from "react";

const PRIMARY_COLOR = "#ffffff"; // background
const ACCENT_COLOR = "#3d0707"; // brand accent

const ResetMail = () => {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        if (!email) {
            setError("Please enter your email address.");
            return;
        }

        // Basic email format validation
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!re.test(email)) {
            setError("Invalid email address.");
            return;
        }

        setIsLoading(true);
        try {
            const response = await fetch("https://portal.lsb.go.ke/api/forget_password/", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }),
            });
            const data = await response.json();
            if (!response.ok) {
                setError(data.detail || "Email not found. Please use the email associated with your account.");
                setIsLoading(false);
                return;
            }

            setSuccess("If an account exists with this email, a reset link has been sent. Please check your inbox (and spam).");
            setEmail("");
        } catch (err) {
            setError("Failed to send reset email. Please try again later.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center" style={{ background: PRIMARY_COLOR }}>
            <div className="max-w-md w-full rounded-lg shadow-lg p-8 bg-white border border-gray-200">
                <h2 className="text-2xl font-bold mb-6 text-center" style={{ color: ACCENT_COLOR }}>
                    Reset Your Password
                </h2>
                <form onSubmit={handleSubmit}>
                    <label className="block mb-2 font-semibold text-sm" htmlFor="email" style={{ color: ACCENT_COLOR }}>
                        Account Email
                    </label>
                    <div className="relative mb-2">
                        <input
                            id="email"
                            type="email"
                            placeholder="Enter your email"
                            autoComplete="email"
                            className="w-full py-3 pl-4 pr-11 rounded-lg border shadow-sm text-sm transition focus:outline-none"
                            style={{
                                border: `1.5px solid ${PRIMARY_COLOR}`,
                                background: "#fff8f3",
                                color: ACCENT_COLOR,
                            }}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-[#b27849] text-lg">
                            <i className="fa-regular fa-envelope"></i>
                        </span>
                    </div>
                    {error && (
                        <div className="py-2 px-8 text-center">
                            <span className="text-red-800 font-medium">{error}</span>
                        </div>
                    )}
                    {success && (
                        <div className="py-2 px-8 text-center">
                            <span className="mb-3 text-green-800 font-medium">{success}</span>
                        </div>
                    )}
                    <button
                        type="submit"
                        disabled={isLoading}
                        className="w-full rounded font-bold py-3 px-7 uppercase tracking-wide text-lg transition"
                        style={{
                            background: ACCENT_COLOR,
                            color: PRIMARY_COLOR,
                            boxShadow: "0 3px 18px #3d07071c",
                            letterSpacing: ".08em",
                            border: `2.5px solid ${PRIMARY_COLOR}`,
                            opacity: isLoading ? 0.7 : 1,
                        }}
                    >
                        {isLoading ? (
                            <span
                                className="inline-block align-middle"
                                style={{
                                    width: 24,
                                    height: 24,
                                    border: `3px solid ${PRIMARY_COLOR}`,
                                    borderTop: `3px solid ${ACCENT_COLOR}`,
                                    borderRadius: "50%",
                                    animation: "spin 1s linear infinite",
                                }}
                            />
                        ) : (
                            "Send Reset Email"
                        )}
                    </button>
                </form>
                <div className="flex justify-center items-center pt-3 text-sm">
                    <a href="/portal" className="text-[#b27849] font-medium hover:underline">Back to login</a>
                </div>
            </div>
            <style>{`
                @media (max-width: 600px) {
                    .max-w-md { max-width: 98vw; }
                    .p-8 { padding-left: 1.25rem; padding-right: 1.25rem; }
                }
                @keyframes spin {
                    from { transform: rotate(0deg);}
                    to { transform: rotate(360deg);}
                }
            `}</style>
        </div>
    );
};

export default ResetMail;